// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"style_modalOverlay__3tgSo","modalWidth":"style_modalWidth__1vtxV","title":"style_title__2A12q","cancel":"style_cancel__2iOpF"};